import React from 'react';
import { Link } from 'react-router-dom';

const AdminPortal = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="admin-hero" style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '120px 0 80px',
        marginTop: '70px',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
            <i className="fas fa-shield-alt me-3"></i>
            Admin Portal
          </h1>
          <p style={{ fontSize: '1.25rem', opacity: '0.95' }}>
            Access the Content Management System
          </p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card shadow-lg" style={{ borderRadius: '15px', overflow: 'hidden' }}>
              <div className="card-header text-center py-4" style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white'
              }}>
                <h2 className="mb-0">Admin & Editor Access</h2>
              </div>
              <div className="card-body p-5">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="text-center">
                      <div className="mb-4" style={{
                        width: '100px',
                        height: '100px',
                        margin: '0 auto',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="fas fa-user-cog fa-3x text-white"></i>
                      </div>
                      <h4>Admin Dashboard</h4>
                      <p className="text-muted mb-4">
                        Full system control, user management, and content moderation
                      </p>
                      <Link
                        to="/login"
                        state={{ isAdmin: true }}
                        className="btn btn-primary btn-lg"
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          border: 'none',
                          borderRadius: '50px',
                          padding: '0.75rem 2rem'
                        }}
                      >
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Admin Login
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="text-center">
                      <div className="mb-4" style={{
                        width: '100px',
                        height: '100px',
                        margin: '0 auto',
                        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <i className="fas fa-edit fa-3x text-white"></i>
                      </div>
                      <h4>Editor Dashboard</h4>
                      <p className="text-muted mb-4">
                        Manuscript review, editorial decisions, and publication management
                      </p>
                      <Link
                        to="/login"
                        state={{ isEditor: true }}
                        className="btn btn-success btn-lg"
                        style={{
                          background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                          border: 'none',
                          borderRadius: '50px',
                          padding: '0.75rem 2rem'
                        }}
                      >
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Editor Login
                      </Link>
                    </div>
                  </div>
                </div>

                <hr className="my-5" />

                <div className="text-center">
                  <h5 className="mb-3">Test Credentials</h5>
                  <div className="alert alert-info" style={{
                    borderRadius: '10px',
                    border: 'none',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)'
                  }}>
                    <p className="mb-2">
                      <strong>Admin:</strong> admin@fuwukari.edu.ng / Your Password
                    </p>
                    <p className="mb-0">
                      <strong>Editor:</strong> editor@fuwukari.edu.ng / Your Password
                    </p>
                  </div>
                </div>

                <div className="mt-4">
                  <h5 className="text-center mb-3">Portal Features</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li><i className="fas fa-check text-success me-2"></i>User Management</li>
                        <li><i className="fas fa-check text-success me-2"></i>Paper Submissions</li>
                        <li><i className="fas fa-check text-success me-2"></i>Review Process</li>
                        <li><i className="fas fa-check text-success me-2"></i>Issue Management</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="list-unstyled">
                        <li><i className="fas fa-check text-success me-2"></i>Editorial Board</li>
                        <li><i className="fas fa-check text-success me-2"></i>Announcements</li>
                        <li><i className="fas fa-check text-success me-2"></i>Statistics & Reports</li>
                        <li><i className="fas fa-check text-success me-2"></i>Email Notifications</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="alert alert-warning mt-4" style={{
                  borderRadius: '10px',
                  border: 'none'
                }}>
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Note:</strong> Access to the admin portal is restricted to authorized personnel only.
                  Unauthorized access attempts will be logged and reported.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPortal;